<template>
  <Container type="card-full">
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{projectList.projectcode}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">平台编号</div>
              <div class="view-value">{{projectList.projectno}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content">{{projectList.projectname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field" v-if="projectList.projectysflg">
              <div class="view-label">预算金额</div>
              <div class="view-value">{{projectList.projectlimitamt | qfwVal}} (<amount :money="String(projectList.projectlimitamt)" v-if="projectList.projectlimitamt"/>)</div>
            </div>
            <div class="view-field">
              <div class="view-label">是否含税</div>
              <div class="view-value">{{projectList.projecthsflg == 1?'含税':'不含税'}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">项目预算</div>
              <div class="view-value">{{projectList.projectysflg?'公开':'不公开'}}</div>
            </div>
          </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">投标截止时间</div>
              <div class="view-value">{{projectList.prsbjbegtime | longDate}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">开标方式</div>
              <div class="view-value">{{+projectList.projectopenbidmode  === 1 ? '现场开标':'远程开标'}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目开标时间</div>
              <div class="view-value">{{projectList.prsbjendtime | longDate}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">开标地点</div>
              <div class="view-content">{{projectList.projectbidaddr}}</div>
            </div>
          </div>
          <div class="split-line"></div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">投标价格</div>
                <div class="view-value"  style="margin-right:20px">
                  <el-input v-model="tbPrice" maxlength="10" @input="changeInput" placeholder="请输入投标价格" @blur="inputMoney($event,'projectlimitamt')">
                    <template slot="append"><span style="color:red">元(人民币)</span></template>
                  </el-input>
                </div>
                <div class="view-value"  v-if="numPrice && numPrice >= 0">
                    <amount :money="String(numPrice)" v-if="numPrice"/>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">上传投标文件</div>
                <div class="view-file">
                    <div class="uploadbtn">
                      <upload-btn @changed='setfile' text="上传投标文件"></upload-btn>
                      <div style="color: #2f74ff;cursor: pointer;margin:10px 0;" v-if="append">
                          <span @click="downFile(append.appendurl)" style="display:inline-block;padding-right: 20px;">
                            <a :src="$store.getters.uploadAddr + append.appendurl">{{append.appendfilename}}</a>
                          </span>
                          <a @click="delappend(append)" v-if="append.appendurl">删除</a>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="view-row" >
              <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <el-button @click="saveTB">保存</el-button>
                  </div>
              </div>
            </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">投标必读</div>
              <div class="view-content" v-html="cosInfo.costbreadinfo"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import uploadBtn from '../common/uploadBtn'
  import dayjs from 'dayjs'
  import amount from '../common/amount'
  import common from '@/mixin/common'
  import utils from '../../assets/js/utils'
  import moment from 'moment'

  export default {
    name: "onlineBidding",
    data () {
      return {
          projectList:{},
          cosInfo:{},
          tbPrice:'',
          numPrice:'',
          psu:{},
          psuid:this.$route.params.psuid,
          append:{},
      }
    },
    mixins: [common],
    created () {
    },
    deactivated () {
    },
    mounted () {
    },
    activated () {
        this.init()
        this.getModel()
        this.getProjectList()
        this.getcositemList()
    },
    filters: {
      longDate (value) {
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      qfwVal (value) {
        if (!!value && +value > 0) {
          return utils.comdify(value)
        } else {
          return value
        }
      }
    },
    computed: {
        uploadAddr() {
            return this.$store.getters.uploadAddr
        }
    },
    components: {uploadBtn,amount},
    methods: {
      init(){
          this.projectList = {}
          this.psu = {}
          this.tbPrice = ''
      },
      async getcositemList(){
        this.loading = true

        let res = await request({
          method: 'get',
          url: '/ywgl/cos/getCosbyid',
          params: {cosid: this.$store.getters.loginUser.cosid}
        })

        this.cosInfo = res[0]

        this.loading = false
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getpsubyid',
          params: {psuid: this.$route.params.psuid}
        })
        this.psu = res[0]
        
        this.tbPrice = this.psu.psuamt?utils.comdify(utils.delcommafy(this.psu.psuamt)):this.psu.psuamt
        this.numPrice = this.psu.psuamt
        await this.getAppends()
      },
      async getAppends () {
        let res= await request({
          method: 'get',
          url: '/ywgl/append/getAppendListByFromId',
          params: {appendfromid: this.$route.params.psuid, appendfromtype: '6'}
        })
        this.append = res[0]
      },
      async getProjectList(){
            let res = await request({
                method: 'get',
                url: '/xmgl/project/findProjectById',
                params: {projectid: this.$route.params.projectid}
            })
            this.projectList = res
            this.projectList.projectysflg = +this.projectList.projectysflg === 1 ? true : false
      },
      async setfile (path, filename) {
        this.append = {
            appendid: 0,
            appendfromid: this.$route.params.psuid,
            appendfromtype: '6',
            appendtype: '100',
            appendseq: 1,
            appendfilecode: '',
            appendfilename: filename,
            appendurl: path.replace(this.uploadAddr,'')
        }
      },
      inputMoney (el, name) {
        let val = utils.delcommafy(el.target.value)
        var reg = /^[0-9]+.?[0-9]*$/
        if ((reg.test(val))) {
          this.tbPrice = utils.getInputValue(el)
        }
      },
      changeInput(val){
        this.numPrice = utils.delcommafy(val)
      },
      delappend (file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          this.append = {appendurl:'',appendfilename: '',appendfromid: this.$route.params.psuid}
        }).catch(() => {
        })
      },
      async saveTB(){
        await this.getProjectList()

        if(moment(new Date()).isAfter(this.projectList.prsbjbegtime)){
          this.$message.warning('开标已经开始，不能继续投标')
          return
        }
        let reg = /^[0-9]+.?[0-9]*$/

        if (Number(this.numPrice) < 0) {
          console.log('数值不能小于0');
          this.$message.warning("数值不能小于0")
          return
        }
        if (!reg.test(Number(this.numPrice))) {
          this.$message.warning("请输入数字")
          return
        }

        if (!this.append) {
          this.$message.warning("请上传投标文件！")
          return
        }

        this.$confirm(`确定提交 ？`, '提示', {
          type: 'warning'
        }).then(async() => {

          let model = {}
          model.tbPrice = utils.delcommafy(this.numPrice)
          model.psuid = this.$route.params.psuid
          model.append = this.append

          let res = await request({
            method: 'post',
            url: '/xmgl/bidOpening/saveTB',
            data: model
          })
          this.close()
        }).catch(() => {
        })
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'bidOpening'})
      },
    }
  }
</script>

<style lang="scss" scoped>
.fliename {
  cursor: pointer;
  color: #2f74ff;
}
.filelist {
/*width: 100%;*/
    padding-top: 10px;
    .fileitem {
        display: flex;
        text-align: left;
        line-height: 40px;
        .name {
        color: #2f74ff;
        cursor: pointer;
        flex: 1;
        }
        .delbtn {
        padding: 0 10px;
        span {
            color: #2f74ff;
            cursor: pointer;
        }
        }
        /*height: 150px;*/
    }
}
</style>
